module.exports = __webpack_public_path__ + "static/img-servo-triple-pack-ea7c72e7ad2ecd39211c06d676325b44.jpg";